var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRingVector1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.626 2.176C31.2563 1.65813 30.7684 1.23591 30.2029 0.944424C29.6373 0.652934 29.0103 0.500575 28.374 0.5H11.626C10.338 0.5 9.12202 1.126 8.29202 2.298L0.292019 15.46C0.0684792 15.8272 -0.0306557 16.2567 0.00933802 16.6848C0.0493318 17.1128 0.226321 17.5166 0.51402 17.836L18.514 37.836C18.7006 38.0457 18.9294 38.2136 19.1854 38.3286C19.4414 38.4437 19.7189 38.5032 19.9996 38.5034C20.2803 38.5036 20.5578 38.4444 20.814 38.3297C21.0702 38.215 21.2992 38.0475 21.486 37.838L39.486 17.838C39.7743 17.5189 39.9517 17.1151 39.9917 16.6869C40.0317 16.2587 39.9322 15.829 39.708 15.462L31.626 2.176ZM20 33.51L6.49002 18.5H33.508L20 33.51ZM5.55402 14.5L11.626 4.5L28.29 4.376L34.444 14.5H5.55402Z",
    fill: "#BD9B5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingVector1);
export default __webpack_public_path__ + "static/media/ring-vector-1.55b5751ad565712486b892b839c7f30a.svg";
export { ForwardRef as ReactComponent };